/**
 * Typography System
 * Standardized text styles for consistent visual hierarchy
 */

export const typography = {
  // Page titles
  pageTitle: 'text-3xl font-bold text-theme-text',
  pageSubtitle: 'text-theme-text-secondary mt-1',
  
  // Section titles
  sectionTitle: 'text-xl font-semibold text-theme-text',
  cardTitle: 'text-lg font-semibold text-theme-text',
  
  // Body text
  body: 'text-base text-theme-text',
  bodySecondary: 'text-sm text-theme-text-secondary',
  caption: 'text-xs text-theme-text-secondary',
  
  // Stats/metrics
  statValue: 'text-2xl font-bold',
  statLabel: 'text-sm text-theme-text-secondary',
  
  // Links
  link: 'text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300',
  
  // Utility classes
  truncate: 'truncate',
  ellipsis: 'text-ellipsis',
} as const;

/**
 * Helper function to combine typography classes
 */
export function cn(...classes: (string | undefined | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

